import PropTypes from "prop-types";
import {CCard, CCardBody, CCardHeader, CCardLink, CCardSubtitle, CCardText, CCardTitle,} from "@coreui/react";

import "@coreui/coreui/dist/css/coreui.min.css";

function EventCard({event}) {
    return (
        <div className="flex justify-center">
            <CCard
                className="w-80 shadow-lg rounded-2xl overflow-hidden bg-gradient-to-br from-white via-purple-50 to-purple-100 transition-transform duration-300 hover:scale-[1.02] hover:shadow-2xl h-auto">
                <CCardHeader className="bg-purple-600 text-white text-center py-3">
                    {event.icon && (
                        <img
                            src={event.icon}
                            alt={event.title}
                            className="w-12 h-12 mx-auto mb-2"
                        />
                    )}
                    {event.title && (
                        <CCardTitle className="text-xl font-semibold tracking-wide">
                            {event.title}
                        </CCardTitle>
                    )}
                    {event.subtitle && (
                        <CCardSubtitle className="text-sm text-purple-200 mt-1">
                            {event.subtitle}
                        </CCardSubtitle>
                    )}
                </CCardHeader>

                <CCardBody className="px-5 py-4">
                    {event.time?.start && (
                        <div className="text-center text-gray-700 font-medium mb-1">
                            🕓 {event.time.start}
                        </div>
                    )}
                    {(event.time?.duration || event.place) && (
                        <div className="text-center text-gray-500 text-sm mb-3">
                            {event.time?.duration && <>Durata: {event.time.duration}<br/></>}
                            {event.place && <>📍 {event.place}</>}
                        </div>
                    )}

                    {event.text && (
                        <CCardText className="text-gray-800 leading-relaxed mb-4 text-justify">
                            {event.text}
                        </CCardText>
                    )}

                    {event.links && event.links.length > 0 && (
                        <div className="flex flex-col items-center gap-2 mt-2">
                            {event.links.map((link) => (
                                <CCardLink
                                    key={link.url}
                                    href={link.url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="px-3 py-1 text-sm text-purple-700 font-medium bg-purple-100 rounded-md hover:bg-purple-200 hover:text-purple-900 transition-all duration-200"
                                >
                                    🔗 {link.text}
                                </CCardLink>
                            ))}
                        </div>
                    )}
                </CCardBody>
            </CCard>
        </div>
    );
}

EventCard.propTypes = {
    event: PropTypes.shape({
        time: PropTypes.shape({
            start: PropTypes.string,
            duration: PropTypes.string,
        }),
        icon: PropTypes.string,
        place: PropTypes.string,
        title: PropTypes.string,
        subtitle: PropTypes.string,
        text: PropTypes.string,
        links: PropTypes.arrayOf(
            PropTypes.shape({
                url: PropTypes.string,
                text: PropTypes.string,
            })
        ).isRequired,
    }).isRequired,
};

export default EventCard;
